import ImageWithButton from './ImageWithButton';
import ImageWithLink from './ImageWithLink';
import TextWithButton from './TextWithButton';
import TextWithLink from './TextWithLink';

export default {
  ImageWithButton,
  ImageWithLink,
  TextWithButton,
  TextWithLink,
};
